<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>

         <ng-container lcsColumnDef="ipAddress" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="ip-address-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="ipAddress"
            >
               IP Address
               <mat-icon class="mat-icon-sort">
                  {{ getSort('ipAddress') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.ipAddress }}
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="customerAccount" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="customer-account-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="account.name"
            >
               Customer Account
               <mat-icon class="mat-icon-sort">
                  {{ getSort('account.name') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.accountName }}
               </button>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="qManageTicket" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="qmanage-ticket-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="qManageTicketId"
            >
               QManage Ticket
               <mat-icon class="mat-icon-sort">
                  {{ getSort('qManageTicketId') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.qManageTicketId }}
               </button>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="originatingType" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="originating-type-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="originatingType"
            >
               Originating Type
               <mat-icon class="mat-icon-sort">
                  {{ getSort('originatingType') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.originatingType }}
               </button>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="status" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="status-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="status"
            >
               Status
               <mat-icon class="mat-icon-sort">
                  {{ getSort('status') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.status }}
               </button>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="createdDate" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="created-date-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="createDate"
            >
               Created Date
               <mat-icon class="mat-icon-sort">
                  {{ getSort('createDate') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.createDate | date : 'MM/dd/yyyy hh:mm aa' : 'UTC' }}
               </button>
            </td>
         </ng-container>

         <ng-container lcsColumnDef="requestedBy" width="2">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="requested-by-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="requestedByUser.name"
            >
               Requested By
               <mat-icon class="mat-icon-sort">
                  {{ getSort('requestedByUser.name') }}
               </mat-icon>
            </th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               <button class="table-button" type="button" (click)="onRowClick(allowedIp)">
                  {{ allowedIp.requestedByUserName }}
               </button>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="allowedIpActionsMenu" width="2">
            <th lcs-header-cell *lcsHeaderCellDef></th>

            <td lcs-cell *lcsCellDef="let allowedIp">
               @if (bannedallowedIpPrivileges?.enabled) {
               <button
                  type="button"
                  aria-label="Allowed IP Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="allowedIpMenu"
                  id="allowed-ip-more-actions"
               >
                  <mat-icon>more_horiz</mat-icon>
               </button>

               <mat-menu #allowedIpMenu="matMenu">
                  <button mat-menu-item type="button" (click)="onRowClick(allowedIp)"> Edit Allowed IP </button>

                  <button
                     mat-menu-item
                     type="button"
                     id="allowed-ip-delete"
                     (click)="onDeleteClick(allowedIp.allowedIpAddressId, allowedIp.ipAddress)"
                  >
                     Remove
                  </button> </mat-menu
               >}
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
